var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScalaDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1865 102.421C66.9311 104.826 81.6418 109.362 103.585 114.086C125.529 118.292 148.349 134.898 166.097 129.777C178.101 126.307 191.124 95.3864 191.124 90.794V90.3225C191.124 87.1163 188.719 84.542 184.636 82.4014C167.898 73.8484 164.729 70.6988 158.524 72.4056C126.312 81.2981 69.4394 76.7528 65.1865 102.421Z",
    fill: "#380D09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1865 165.206C66.9311 167.648 81.6418 172.146 103.585 176.88C128.103 181.35 149.424 195.919 167.181 190.79C179.185 187.319 191.124 158.181 191.124 153.579V153.126C191.124 149.93 188.719 147.346 184.636 145.215C171.868 138.425 154.997 130.947 148.802 132.654C116.533 141.527 73.4 143.479 65.1865 165.206Z",
    fill: "#380D09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0073 115.916V116.368C64.9976 116.217 64.9976 116.066 65.0073 115.916V115.916Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.134 40.1364C137.467 48.7082 90.4021 53.5458 65.0449 53.5458V101.969C65.053 102.135 65.116 102.294 65.2241 102.421C82.5281 102.421 135.949 96.7633 168.18 87.8991C173.802 86.4684 179.313 84.6374 184.673 82.4203C188.615 80.6475 191.161 78.7803 191.161 76.8378V28C191.123 32.6018 179.138 36.6756 167.134 40.1364V40.1364Z",
    fill: "#DE3423"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.134 102.931C149.377 108.051 125.416 111.861 103.585 114.086C88.931 115.586 75.2387 116.368 65.0449 116.368V164.753C65.053 164.92 65.116 165.079 65.2241 165.206C82.5281 165.206 135.949 159.548 168.18 150.693C173.8 149.258 179.312 147.428 184.673 145.214C188.615 143.432 191.161 141.575 191.161 139.632V90.7942C191.123 95.3866 179.138 99.4603 167.134 102.931V102.931Z",
    fill: "#DE3423"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.134 165.762C149.377 170.883 125.416 174.683 103.585 176.918C88.9123 178.417 75.2011 179.2 65.0073 179.2V228C82.1321 228 135.826 222.389 168.143 213.487C180.053 210.206 191.124 206.471 191.124 202.416V153.579C191.124 158.218 179.138 162.254 167.134 165.762V165.762Z",
    fill: "#DE3423"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalaDark);
export default __webpack_public_path__ + "static/media/Scala-Dark.da303d4bb60626541d6216681c155f8b.svg";
export { ForwardRef as ReactComponent };